// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28YVx","colMin":"styles_colMin__1KvNn"};